import PropTypes from "prop-types";
import { Checkout } from "vino/components";

const Block = ({ attributes }) => {
	return <Checkout />;
};

Block.propTypes = {
	attributes: PropTypes.object,
};

export default Block;
